import { getTableLang } from "../../Utils/Inits/getTableLang";
import { changeCourseListItem } from "../AdminCourseManagement/Fills";


export function loadSubmissions(){

    const columns = $("thead").find("th").length

    const datatableConfig = {
        language: getTableLang({}, ['Abgaben', 'Abgabe']),
        columnDefs: [
            {"orderable": false, "targets": [columns - 1]} // only last not
        ]
    }

    let table = $("#student-submissions").DataTable(datatableConfig);



    const fillStudentSubmissionsList = function(courseId){
        const config = {
            data: {
                action: "fill_student_submissions",
                courseId: courseId,
            },
            success: function(data){
                if (data.success){
                    table.destroy();
                    const submissionsTable = $("#student-submissions");
                    submissionsTable.html(data.html);
                    table = $("#student-submissions").DataTable(datatableConfig);
                }
            }
        };
        ajax(config);
    }

    const submissionsListInitCourse = function(courseId){
        fillStudentSubmissionsList(courseId);
    }

    $("#student-course-list").on("click", ".m-f-t-item", function(){
        const courseId = changeCourseListItem($(this));
        submissionsListInitCourse(courseId);
    });
}
